import { cap } from '../utilities/utilities';

export default function PagesHeader( props ) {

	//const hideColumns = [ 'id', 'created', 'modified', 'ordinal', 'admin_user_id' ]

	if ( !props.structure || !props.structure.hasOwnProperty( props.table ) ) return false

	return <tr>
		{ props.select && <td style={{  whiteSpace:'pre', fontWeight:700, background:'#eee', padding:'8px 16px', textAlign:'center' }} >Select</td> }

		{ props.showColumns.map( ( showColumn, i ) => { 

			//const c = props.structure[ props.table ].filter( e => e.column_name === showColumn )[ 0 ] 
			const structureColumns = props.structure[ props.table ].filter( e => e.column_name === showColumn )
			const c = structureColumns.length > 0 ? structureColumns[ 0 ] : { column_name:showColumn }

			return (
				<td 
					key={ i }
					style={{ whiteSpace:'pre', fontWeight:700, background:'#eee', padding:'8px 16px' }} 
				>
					{ cap( c.column_name ) }
				</td>
		) } ) }
	</tr>
}
